<template>
  <div>
    <!-- margin:{{margin}} -->
    <div
v-if="type == 'margin'"
class="margin_container"
>
      <div
v-for="(item, index) in margin"
:key="index"
class="margin_box"
>
        <div
v-if="quoteType[index] == 0"
style=""
>
          <el-input
            v-model="margin[index]"
            width="32px"
            :data-index="index"
            type="number"
            @change="marginHandle(index)"
          />

          <div class="margin_box_text">
            {{ margin_index[index] }}
          </div>
        </div>
      </div>
    </div>
    <div
v-else
class="margin_container"
>
      <div
v-for="(item, index) in padding"
:key="index"
class="margin_box"
>
        <div
v-if="quoteType[index] == 0"
style=""
>
          <el-input
            v-model="padding[index]"
            width="32px"
            :data-index="index"
            type="number"
            @change="marginHandle(index)"
          />

          <div class="margin_box_text">
            {{ margin_index[index] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SpMargin',
  mixins: [mixin],
  props: {
    value: {
      type: Array,
      default: () => {
        return [0, 0, 0, 0]
      }
    },
    quoteType: {
      type: Array,
      default: () => {
        return [0, 0, 0, 0]
      }
    },
    type: {
      type: String,
      default: 'margin'
    }
  },
  data () {
    return {
      margin_index: ['上', '右', '下', '左'],
      margin: [0, 0, 0, 0],
      padding: [0, 0, 0, 0]
    }
  },
  watch: {},
  created () {
    console.log('this.margin', this.margin)
  },
  mounted () {
    if (!this.margin || this.margin.length == 0) {
      this.margin = [0, 0, 0, 0]
    }
    if (!this.padding || this.padding.length == 0) {
      this.padding = [0, 0, 0, 0]
    }
  },
  methods: {
    marginHandle (index) {
      if (this.type == 'string') {
        if (this.margin[index] == '') this.$set(this.margin, index, 0)
      } else if (this.padding[index] == '') this.$set(this.padding, index, 0)
    }
  }
}
</script>

<style scoped lang="scss">
.margin_container {
  display: flex;
}
.margin_box {
  // width:32px;
  // line-height:32px;
  width: 20%;
  margin-right: 8px;
  text-align: center;
  .margin_box_text {
    margin-top: 4px;
  }
}
</style>
